import { z } from "zod";

export const editAssessmentSchema = z.object({
  text: z.string().nonempty("Required"),
});
